"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M11.98 0h-8c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V6l-6-6zm4 18h-11V2h6v5h5v11z"];
//# sourceMappingURL=document.js.map